// extracted by mini-css-extract-plugin
export default {"content":"JobOfferForm-BlockContent__content--PQBiu"};